import {
  IconBell,
  IconNotes,
  IconUsers,
  IconSchool,
  IconPencil,
  IconDevices,
  IconMoodKid,
  IconFileText,
  IconSettings,
  IconUserCircle,
  IconUserShield,
  IconLayoutDashboard,
  IconReportAnalytics,
  IconMessage2Question,
} from '@tabler/icons-react';

import { ERoleAccess } from '@/enum';

export const sidebarMenu = [
  {
    id: 1,
    name: 'sidebar.dashboard',
    icon: IconLayoutDashboard,
    link: '/',
    disabled: false,
    permission: true,
    hidden: false,
  },
  {
    id: 2,
    name: 'sidebar.user-management',
    icon: IconUserCircle,
    link: '#',
    disabled: false,
    permissions: false,
    hidden: false,
    sectionName: ERoleAccess.USER_MANAGEMENT,
    children: [
      {
        id: '2-1',
        name: 'sidebar.children',
        link: '/user-management/children/personal',
        disabled: false,
        icon: IconMoodKid,
      },
      {
        id: '2-2',
        name: 'sidebar.parents',
        link: '/user-management/parents',
        disabled: false,
        icon: IconUsers,
      },
      {
        id: '2-3',
        name: 'sidebar.teachers',
        link: '/user-management/teacher',
        disabled: false,
        icon: IconPencil,
      },
      {
        id: '2-4',
        name: 'sidebar.schools',
        link: '/user-management/school',
        disabled: false,
        icon: IconSchool,
      },
      {
        id: '2-5',
        name: 'sidebar.admin',
        link: '/user-management/admin',
        disabled: false,
        icon: IconUserShield,
      },
    ],
  },
  {
    id: 3,
    name: 'sidebar.content-management',
    icon: IconFileText,
    link: '/content-management',
    disabled: false,
    permissions: false,
    sectionName: ERoleAccess.CONTENT_MANAGEMENT,
  },
  {
    id: 4,
    name: 'sidebar.reports-analytics',
    icon: IconReportAnalytics,
    link: '/report-analytics/overview',
    disabled: false,
    permission: false,
    sectionName: ERoleAccess.REPORTS_ANALYTICS,
  },
  {
    id: 5,
    name: 'sidebar.device-management',
    icon: IconDevices,
    link: '/device-management',
    disabled: false,
    permission: true,
    sectionName: ERoleAccess.DEVICE_MANAGEMENT,
  },
  {
    id: 6,
    name: 'sidebar.support-queries',
    icon: IconMessage2Question,
    link: '/support-queries',
    disabled: false,
    permission: false,
    sectionName: ERoleAccess.SUPPORT_QUERIES,
  },
  {
    id: 7,
    name: 'sidebar.editorial-management',
    icon: IconNotes,
    link: '/editorial-management',
    disabled: false,
    permission: false,
    sectionName: ERoleAccess.EDITORIAL_MANAGEMENT,
  },
  {
    id: 8,
    name: 'sidebar.notifications',
    icon: IconBell,
    link: '/notifications',
    disabled: false,
    onlyForAdmin: false,
    permission: false,
    sectionName: ERoleAccess.NOTIFICATIONS,
  },
  {
    id: 9,
    name: 'sidebar.settings',
    icon: IconSettings,
    link: '/settings',
    disabled: false,
    onlyForAdmin: false,
    permission: false,
  },
];
